import { useTranslation } from "react-i18next";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { ClearableSelectAdornment } from "./ClearSelectAdornment";

export default function ClearableSelect({
  param,
  deleteParams = [],
  label,
  options = [],
  disabled = false,
  resetOption = false,
  testId,
  ...selectProps
}) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedValue = searchParams.get(param) ?? "";

  function handleFilterChange(value) {
    searchFn(value);
  }

  function handleClear() {
    searchFn("");
  }

  function searchFn(value) {
    const params = new URLSearchParams(searchParams);

    if (!value) {
      params.delete(param);
      if (deleteParams.length > 0) {
        deleteParams.forEach((val) => params.delete(val));
      }
    } else {
      params.set(param, value);
    }

    params.set("page", "0");
    setSearchParams(params);
  }

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{t(label)}</InputLabel>
      <Select
        value={selectedValue}
        label={t(label)}
        onChange={(e) => handleFilterChange(e.target.value)}
        disabled={disabled}
        data-testid={testId}
        {...selectProps}
      >
        {resetOption && (
          <MenuItem
            value={""}
            data-testid={testId ? `${testId}.option.reset` : undefined}
          >
            {t("Reset")}
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            data-testid={
              testId ? `${testId}.option.${option.value}` : undefined
            }
          >
            {t(option.label)}
          </MenuItem>
        ))}
      </Select>
      <ClearableSelectAdornment value={selectedValue} onClear={handleClear} />
    </FormControl>
  );
}
